import { render } from "./uploading.vue?vue&type=template&id=7c383819&scoped=true"
import script from "./uploading.vue?vue&type=script&lang=js"
export * from "./uploading.vue?vue&type=script&lang=js"

import "./uploading.vue?vue&type=style&index=0&id=7c383819&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c383819"]])

export default __exports__